import { PdfReportType } from 'api/Data/types';
import { SelectOption } from 'app/types/Forms';
import { useAppSelector } from 'store/hooks';
import { selectMyUser } from 'store/users/usersSlice';

import { useMemo } from 'react';

const usePdfPrsReportTypes = () => {
  const {
    org: {
      reportPrsRuoCardioEnabled,
      reportPrsRuoCancerEnabled,
      reportPrsClinicalCardioEnabled,
      reportPrsClinicalCancerEnabled,
    },
  } = useAppSelector(selectMyUser);

  const reportTypeOptions: SelectOption<PdfReportType>[] = useMemo(() => {
    const arr: SelectOption<PdfReportType>[] = [];

    if (reportPrsRuoCardioEnabled) {
      arr.push({ value: 'PRS_RUO_CARDIO', label: 'RUO cardio' });
    }

    if (reportPrsRuoCancerEnabled) {
      arr.push({ value: 'PRS_RUO_CANCER', label: 'RUO cancer' });
    }

    if (reportPrsClinicalCardioEnabled) {
      arr.push({ value: 'PRS_CLINICAL_CARDIO', label: 'Clinical cardio' });
    }

    if (reportPrsClinicalCancerEnabled) {
      arr.push({ value: 'PRS_CLINICAL_CANCER', label: 'Clinical cancer' });
    }

    return arr;
  }, [ reportPrsRuoCardioEnabled, reportPrsRuoCancerEnabled, reportPrsClinicalCardioEnabled, reportPrsClinicalCancerEnabled ]);

  const reportTypes = useMemo(
    () => reportTypeOptions.map(r => r.value),
    [ reportTypeOptions ],
  );

  return { reportTypeOptions, reportTypes };
};

export default usePdfPrsReportTypes;
